import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import Landing from './components/Landing'
import Login from './components/Login'
import Dashboard from './components/Dashboard'
import TemplateManagement from './components/TemplateManagement'
import PrivateRoute from './components/PrivateRoute'
import AuthDebug from './components/AuthDebug'
import DebugTemplate from './components/DebugTemplate'

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/auth-debug" element={<AuthDebug />} />
          <Route path="/debug-template" element={<DebugTemplate />} />
          <Route 
            path="/dashboard" 
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/templates" 
            element={
              <PrivateRoute>
                <TemplateManagement />
              </PrivateRoute>
            } 
          />
        </Routes>
      </AuthProvider>
    </Router>
  )
}

export default App
